import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import {
  NgxExtendedPdfViewerModule,
  pdfDefaultOptions,
} from 'ngx-extended-pdf-viewer';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ButtonModule, NgxExtendedPdfViewerModule],
})
export class PdfViewerComponent {
  @Input() url: string;

  @Input() fileName = 'document.pdf';

  @Input() zoom = 'auto';

  @Input() theme = 'dark';

  constructor() {
    pdfDefaultOptions.assetsFolder = 'assets/pdf-viewer';
  }
}
